import { gql } from "@apollo/client";

const VERIFICATION_CODE_SEND = gql`
  mutation send($phoneNumber: String!) {
    verificationCodeSend(phoneNumber: $phoneNumber) {
      status
      message
    }
  }
`;

const VERIFICATION_CODE_CHECK = gql`
  mutation check($phoneNumber: String!, $code: String!) {
    verificationCodeCheck(phoneNumber: $phoneNumber, code: $code) {
      status
      message
    }
  }
`;

const UPDATE_VERIFY_PHONE_STEP = gql`
  mutation finishPhoneStep {
    updatePhoneStep {
      status
      message
    }
  }
`;

export {
  UPDATE_VERIFY_PHONE_STEP,
  VERIFICATION_CODE_SEND,
  VERIFICATION_CODE_CHECK,
};
